import AccountSuccessForm from './AccountSuccessForm';

export * from './AccountSuccessForm';
export default AccountSuccessForm;
